module.exports = __webpack_public_path__ + "static/media/sound-desk.fe3bc395.jpg";